/* 關張傳・第 1 章：江州・義釋嚴顏（建安十九年，214）
 * 史實：《三國志·先主傳》「諸葛亮、張飛、趙雲等將兵溯流定白帝、江州、江陽，惟關羽留鎮荊州。」
 *       《張飛傳》「至江州，破璋將巴郡太守嚴顏，生獲顏。飛呵顏曰：『大軍至，何以不降而敢拒戰？』顏答曰：『卿等無狀，侵奪我州，
 *       我州但有斷頭將軍，無有降將軍也。』飛怒，令左右牽去斫頭，顏色不變，曰：『斫頭便斫頭，何為怒邪！』飛壯而釋之，引為賓客。
 *       飛所過戰克，與先主會於成都。」（張飛醉酒誘嚴顏出城是演義。）
 * 流程：1. 登岸，頂著城上的箭雨撞開東門。
 *       2. 城裡嚴顏死戰：他打不死，血量見底就力屈被制住，站到他身邊綁起來（生獲）。
 *       3. 呵顏：照原文對答；到刀斧手那邊下令斫頭；嚴顏「斫頭便斫頭」之後二選一——回去解縛（釋之，如史），或再去下令（斬之，失敗）。
 *       4. 所過戰克：嚴顏成了賓客跟著走。往成都的路上兩處營壘：帶嚴顏走近，他出面勸降（讀條），營中的兵就降了跟著走。出西邊即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, rout, vanish, TROOPS } from '../kit.ts';
import { GZ, SOLDIER, spare, hold, calm } from './guanzhang_kit.ts';
import { CITY, EGATE, LAND, FORTS, EXIT } from '../maps/guanzhang_jiangzhou.ts';

const LV = 13, RAM = 4, RAM_AT = [EGATE[0] + 130, EGATE[1]], AXE = [CITY.x + 320, CITY.y + 200];
const YI = { spec: SOLDIER.yizhou, name: '益州兵', hp: 460, maxHp: 460, atk: 26 };

export default {
  id: 'guanzhang-1', map: 'guanzhang_jiangzhou', hero: 'zhangfei',
  title: '第 1 章　江州・義釋嚴顏', year: '建安十九年（214）',
  brief: {
    quote: [{ text: '至江州，破璋將巴郡太守嚴顏，生獲顏。', src: '《三國志·蜀書·張飛傳》' }],
    text: '劉備入蜀，與劉璋反目，圍雒城久攻不下。諸葛亮、張飛、趙雲帶兵從荊州溯江而上，平定沿江郡縣。劉備初入蜀時，巴郡太守嚴顏就嘆過：「此所謂獨坐窮山，放虎自衛也！」（《華陽國志》，裴注）',
    goals: ['登岸，撞開江州東門', '生擒嚴顏（他打不死，力屈後綁起來）', '呵顏：斬，還是釋？', '帶嚴顏西進，沿路營壘不戰而下'],
  },
  words: { ally: '二十騎', foe: '益州兵' },
  stars: [
    { text: '登岸後 90 秒內撞開城門', ok: (m) => m.vars.gateT != null && m.vars.gateT < 90 },
    { text: '飛所過戰克：兩處營壘都由嚴顏勸降', ok: (m) => m.vars.swayed === 2 },
    { text: '親兵折損不超過 2 人', ok: (m) => m.stats.lost <= 2 },
  ],
  steps: [
    { // 0. 登岸撞門
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = LAND[0] - 200; me.y = LAND[1] - 60;
        V.t0 = w.t; V.ram = RAM; V.volT = 3;
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(me.x + 60 + (i % 4) * 50, me.y + 80 + Math.floor(i / 4) * 70, '親兵'); u.spec = TROOPS.shu; m.join(u, me); return u; });
        m.gate('east', EGATE[0], EGATE[1], 170, 'citygate', ['城上', '江州城堅，叫你們有來無回！'], { hp: RAM, hp0: RAM });
        V.out = Array.from({ length: 6 }, (_, i) => m.foe('huangjin', EGATE[0] + 350 + (i % 3) * 90, EGATE[1] - 140 + Math.floor(i / 3) * 260, YI));
        m.card('諸葛亮、張飛、趙雲等將兵溯流定白帝、江州、江陽，惟關羽留鎮荊州。', '《先主傳》');
        m.line('張飛', '溯江一路上來，就剩這江州了。給我撞開城門！');
        m.after(4, () => m.line('提示', '站在城門前不動就會撞門；城頭的弓手會往你身上射（紅圈），被射中撞門就斷了。'));
        m.mark('gate', RAM_AT[0], RAM_AT[1], '江州東門');
        m.obj('gate', '撞開江州東門', RAM);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, g = m.gates.find((o) => o.id === 'east');
        // 城頭的箭：張飛到了城下才射，紅圈落在他站的地方
        V.volT -= dt;
        if (V.volT <= 0 && m.near(me, EGATE[0], EGATE[1], 800)) { V.volT = 2.2; m.strike(me.x, me.y, 150, 1.1, 90, 0); }
        m.chanAt(me, 'ram', RAM_AT[0], RAM_AT[1], 170, 1.5, '撞門', () => { V.ram--; g.hp = V.ram; m.prog('gate', RAM - V.ram); w.fx({ k: 'boom', x: EGATE[0], y: EGATE[1], r: 120, col: '#c8a060' }); });
        return V.ram <= 0;
      },
    },
    { // 1. 生獲嚴顏
      enter(m, w) {
        const V = m.vars;
        V.gateT = w.t - V.t0;
        m.done('gate'); m.unmark('gate'); m.ungate('east');
        m.big('城門破了！');
        V.yan = boss(w, GZ.yanyan, CITY.x - 150, CITY.y, { name: '嚴顏', hp: 3400, atk: 44, armor: 8, ms: 240 });
        V.guard = Array.from({ length: 8 }, (_, i) => m.foe('huangjin', CITY.x - 50 + (i % 4) * 90, CITY.y - 200 + Math.floor(i / 4) * 400, YI));
        spare(w, V.yan, (u) => {
          hold(u); V.down = true;
          m.line('嚴顏', '……力屈至此。要殺便殺！');
          rout(m, w, V.guard, [WGATE_X(), CITY.y]); m.line('益州兵', '太守被擒了！'); // 主將被制住，左右潰散
          m.mark('yan', u.x, u.y, '生獲嚴顏');
          m.after(2, () => m.line('提示', '站到嚴顏身邊不動，把他綁起來。'));
        });
        m.line('嚴顏', '我州但有死戰之將！');
        m.after(3, () => m.line('提示', '嚴顏打不死：把他打到力屈，再綁起來。'));
        m.mark('yan', V.yan.x, V.yan.y, '嚴顏', false, V.yan);
        m.obj('yan', '生擒嚴顏');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (V.down) m.chanAt(me, 'bind', V.yan.x, V.yan.y, 150, 1.5, '生獲', () => { V.caught = true; });
        return !!V.caught;
      },
    },
    { // 2. 呵顏
      enter(m, w) {
        const V = m.vars;
        m.done('yan'); m.unmark('yan');
        m.card('生獲顏。', '《張飛傳》');
        V.axe = m.folk(AXE[0], AXE[1], { name: '刀斧手', still: true, near: 1, cloth: '#5a2a22' });
        m.after(1.5, () => m.line('張飛', '大軍至，何以不降而敢拒戰？'));
        m.after(5, () => m.line('嚴顏', '卿等無狀，侵奪我州，我州但有斷頭將軍，無有降將軍也。'));
        m.after(9, () => { V.order = true; m.mark('axe', AXE[0], AXE[1], '刀斧手'); m.line('提示', '張飛大怒——到刀斧手那邊下令。'); });
        m.obj('he', '呵顏');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (V.order && !V.ordered) m.chanAt(me, 'order', AXE[0], AXE[1], 140, 1, '下令', () => {
          V.ordered = true; m.unmark('axe');
          m.line('張飛', '牽出去，斫頭！');
          m.after(3, () => m.line('嚴顏', '斫頭便斫頭，何為怒邪！'));
          m.after(4, () => m.card('飛怒，令左右牽去斫頭，顏色不變。', '《張飛傳》'));
          m.after(7, () => {
            V.choose = true;
            m.mark('free', V.yan.x, V.yan.y, '釋之'); m.mark('kill', AXE[0], AXE[1], '斬之');
            m.line('提示', '回到嚴顏身邊替他解縛（釋之），或到刀斧手那邊再下令（斬之）。');
          });
        });
        if (!V.choose) return false;
        if (!m.near(me, AXE[0], AXE[1], 260)) V.left = true; // 剛下完令站在刀斧手旁邊：先走開才算再下令
        m.chanAt(me, 'free', V.yan.x, V.yan.y, 150, 2, '解縛', () => { V.freed = true; });
        if (V.left) m.chanAt(me, 'kill', AXE[0], AXE[1], 140, 2, '斬之', () => { V.killed = true; });
        if (V.killed) { m.line('張飛', '斬！'); m.lose('斬了嚴顏——巴蜀從此人人死守'); return false; }
        return !!V.freed;
      },
    },
    { // 3. 所過戰克
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('he'); m.unmark('free'); m.unmark('kill');
        m.card('飛壯而釋之，引為賓客。', '《張飛傳》');
        const at = [V.yan.x, V.yan.y];
        vanish(w, V.yan);
        V.guest = ally(w, GZ.yanyan, at[0], at[1], LV - 2);
        m.after(2, () => m.line('嚴顏', '……將軍壯士也。巴郡諸營，老夫去說。'));
        V.swayed = 0;
        V.forts = FORTS.map(([x, y], k) => {
          const g = Array.from({ length: 6 }, (_, i) => { const u = m.foe('huangjin', x - 120 + (i % 3) * 120, y - 60 + Math.floor(i / 3) * 120, YI); u.asleep = true; u.untargetable = true; return u; }); // 營兵守在營裡觀望（打不到，免得自動攻擊去惹）
          m.mark('f' + k, x + 300, y, '營壘');
          return { x, y, g, done: false };
        });
        m.mark('exit', EXIT[0], EXIT[1], '往成都');
        m.after(4, () => m.line('提示', '帶著嚴顏走近營壘，站在營門前讓他出面勸降；直接打也行。'));
        m.obj('forts', '沿路營壘：勸降或攻破', 2);
        m.obj('exit', '西進成都');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, Y = V.guest;
        const yd = Y.alive ? SG.gd(Y.x, Y.y, me.x, me.y) : 1e9, yanNear = yd < 400; // 嚴顏在身邊才勸得動；落後一點營兵還看得到他（800 內不動手）
        V.forts.forEach((F, k) => {
          if (F.done) return;
          for (const u of F.g) if (u.alive && u.asleep) {
            u.target = null; u.think = 0.5;
            if (u.hp < u.maxHp || (SG.gd(u.x, u.y, me.x, me.y) < 260 && yd > 800)) { for (const o of F.g) { o.asleep = false; o.untargetable = false; } F.forced = true; m.line('益州兵', '是張飛！殺！'); break; }
          }
          if (!F.forced && yanNear) m.chanAt(me, 'sway' + k, F.x + 300, F.y, 220, 3, '嚴顏勸降', () => {
            F.done = true; V.swayed++; m.unmark('f' + k);
            m.line('嚴顏', '老夫都降了，爾等還守什麼？開營！');
            for (const u of m.alive(F.g)) { u.team = 0; u.asleep = false; u.untargetable = false; u.recruit = true; u.spec = TROOPS.shu; u.name = '降卒'; m.join(u, me); }
          }, { hurt: false });
          if (F.forced && !F.g.some((u) => u.alive && u.team === 1)) { F.done = true; m.unmark('f' + k); }
        });
        m.prog('forts', V.forts.filter((F) => F.done).length);
        return V.forts.every((F) => F.done) && m.near(me, EXIT[0], EXIT[1], 300);
      },
    },
    { // 4. 與先主會於成都
      enter(m, w) {
        m.done('exit'); m.unmark('exit');
        m.card('飛所過戰克，與先主會於成都。', '《張飛傳》');
        m.after(5, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('張飛陣亡'); return; }
    calm(w);
    if (V.guest) allyTick(w, V.guest, w.player);
  },
};
function WGATE_X() { return CITY.x - CITY.hw - 300; }
